import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "components/NoScrollDialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDInput from "components/MDInput";
import LoadingButton from "components/LoadingButton";
import { Grid } from "@mui/material";
import TranslatableTextField from "components/TranslatableTextField";
import { useLanguage } from "contexts/language.context";

export default function CategoryDialog({
  isOpen,
  type,
  action,
  data,
  onSubmit,
}) {
  const { label } = useLanguage();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [category, setCategory] = React.useState({
    description: { en: "" },
  });

  const [subcategory, setSubcategory] = React.useState({
    description: { en: "" },
  });

  React.useEffect(() => {
    if (!isOpen) return;
    setOpen(true);
    setLoading(false);

    if (action != "edit") {
      setCategory({
        description: { en: "" },
      });
      setSubcategory({
        description: { en: "" },
      });
    }
  }, [isOpen]);

  React.useEffect(() => {
    if (action == "create") {
      if (type == "category") {
        setCategory({
          description: { en: "" },
        });
        setSubcategory({
          description: { en: "" },
        });
      } else {
        setCategory({
          ...data?.category,
          description: data?.category?.allLanguageDescription,
        });
        setSubcategory({
          description: { en: "" },
          categoryId: data?.category?.id,
        });
      }
    } else {
      if (data?.category)
        setCategory({
          ...data?.category,
          description: data?.category?.allLanguageDescription,
        });
      if (data?.subcategory)
        setSubcategory({
          ...data?.subcategory,
          categoryId: data?.category?.id,
          description: data?.subcategory?.allLanguageDescription,
        });
    }
  }, [data]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: async (event) => {
          event.preventDefault();

          setLoading(true);
          if (type == "category") {
            const result = await onSubmit(category);
            if (result.success) {
              handleClose();
            }

            setLoading(false);
          } else {
            const result = await onSubmit(subcategory);
            if (result.success) {
              handleClose();
            }

            setLoading(false);
          }
        },
      }}
    >
      <DialogTitle>
        {action == "edit"
          ? type == "category"
            ? label("edit-category")
            : label("edit-subcategory")
          : type == "category"
            ? label("create-category")
            : label("create-subcategory")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1} sx={{ pt: 1.5 }}>
          <Grid item xs={12}>
            <TranslatableTextField
              id="category name-input"
              autoFocus
              required
              name="cat"
              label={
                type == "category"
                  ? label("category-singular")
                  : label("subcategory-singular")
              }
              type="text"
              values={
                (type == "category"
                  ? category.description
                  : subcategory.description) || ""
              }
              onChange={(e) => {
                if (type == "category") {
                  setCategory({ ...category, description: e.target.value });
                } else {
                  setSubcategory({
                    ...subcategory,
                    description: e.target.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{label("cancel-button")}</Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="gradient"
          color="info"
        >
          {action == "edit" ? label("save-button") : label("create-button")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
